import { createFileRoute } from '@tanstack/react-router';
import { Webhook } from 'lucide-react';
import { usePageHeader } from '@/components/PageHeader';

export const Route = createFileRoute('/_app/webhooks')({
  component: WebhooksPage,
});

export function WebhooksPage() {
  // Title lives in the Topbar (navTitle); placeholder page has no list/count,
  // so publish nothing — the Topbar falls back to the static navSubtitle.
  usePageHeader({});

  return (
    <>
      <div className="rounded-[var(--radius-card)] border border-[var(--border-hairline)] bg-card px-6 py-12 text-center">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-[var(--radius-control)] bg-[var(--surface-sunken)]">
          <Webhook className="h-6 w-6 text-muted" aria-hidden="true" />
        </div>
        <p className="text-[15px] font-semibold text-[var(--text-heading)]">
          Subscription management is coming soon
        </p>
        <p className="mx-auto mt-2 max-w-md text-sm text-muted">
          It lands with Phase 0.6c-3. In the meantime, manage webhook subscriptions from the CLI:
        </p>
        <code className="mt-4 inline-block rounded-[var(--radius-control)] border border-[var(--border-hairline)] bg-[var(--surface-sunken)] px-2.5 py-1 font-mono text-xs text-[var(--text-heading)]">
          pms-cli webhooks
        </code>
      </div>
    </>
  );
}
